import { IInitialValues } from "./InitialCalcConfig";
import { t } from "../utils/intl";
import { ProductConfig } from "../types/requestTypes";
import { getFormatCurrencyValue } from "../helpers/customHooks/getFormatCurrencyValue";

export interface IValidationResult {
  isInvalid: boolean;
  invalidMessage: string;
}
const frequencyCodeNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.frequencyCode,
    invalidMessage: t("form.Empty")
  };
};

const durationInYearsNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.durationInYears,
    invalidMessage: t("form.Empty")
  };
};

const premiumPerFreqNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.premiumPerFreq,
    invalidMessage: t("form.Empty")
  };
};

const sumAssuredNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.sumAssured,
    invalidMessage: t("form.Empty")
  };
};

const investmentProfileNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.investmentProfile,
    invalidMessage: t("form.Empty")
  };
};

const premiumPerFreqCheckLimits = (config: ProductConfig, form: IInitialValues) => {
  let result: IValidationResult = {
    isInvalid: false,
    invalidMessage: ""
  };

  if (!form.frequencyCode || !form.premiumPerFreq) {
    return result;
  }

  const perFreqLimit = config.validations.premiumperfreqlimits.find(
    el => el.frequencycode === form.frequencyCode
  );

  if (!perFreqLimit) return result;

  const minResult = {
    isInvalid: +form.premiumPerFreq < +perFreqLimit.min,
    invalidMessage: t("form.minDefaultPremiumPerFreq", {
      min: getFormatCurrencyValue(perFreqLimit.min)
    })
  };

  const maxResult = {
    isInvalid: +form.premiumPerFreq > +perFreqLimit.max,
    invalidMessage: t("form.maxDefaultPremiumPerFreq", {
      max: getFormatCurrencyValue(perFreqLimit.max)
    })
  };

  if (minResult.isInvalid) return minResult;
  if (maxResult.isInvalid) return maxResult;

  return result;
};

const sumAssuredCheckLimits = (config: ProductConfig, form: IInitialValues) => {
  let result: IValidationResult = {
    isInvalid: false,
    invalidMessage: ""
  };

  if (!form.sumAssured) {
    return result;
  }

  const minResult = {
    isInvalid: +form.sumAssured < config.validations.sumAssuredLimitMin,
    invalidMessage: t("form.minDefaultSumAssured", {
      min: getFormatCurrencyValue(config.validations.sumAssuredLimitMin)
    })
  };

  const maxResult = {
    isInvalid: +form.sumAssured > config.validations.sumAssuredLimitMax,
    invalidMessage: t("form.maxDefaultSumAssured", {
      max: getFormatCurrencyValue(config.validations.sumAssuredLimitMax)
    })
  };

  if (minResult.isInvalid) return minResult;
  if (maxResult.isInvalid) return maxResult;

  return result;
};

export const standardValidations = [
  {
    id: "frequencyCode",
    validations: [frequencyCodeNotEmpty]
  },
  {
    id: "durationInYears",
    validations: [durationInYearsNotEmpty]
  },
  {
    id: "premiumPerFreq",
    validations: [premiumPerFreqNotEmpty, premiumPerFreqCheckLimits]
  },
  {
    id: "sumAssured",
    validations: [sumAssuredNotEmpty, sumAssuredCheckLimits]
  },
  {
    id: "investmentProfile",
    validations: [investmentProfileNotEmpty]
  }
];
